<div class="chat-detail" *ngIf="chat()" [class.keyboard-open]="isKeyboardOpen" [class.compact]="compactChat">
  @if(!compactChat){
    <div class="document-info">
      <button mat-icon-button (click)="goBack()" aria-label="Back">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="chat-image">
        <div class="chat-image-container" style="background-image: url('{{ chat().picture | thumbnail }}')">
        </div>
      </div>
      
      <div class="chat-info">
        <app-chat-document-chip [chat]="chat()"></app-chat-document-chip>
        <h3>{{ chat().subtitle }}</h3>
        
        <p><b>{{ chat().title }}</b> <i>#{{chat().correlative_id}}</i></p>
        
      </div>
      <div class="open-document" *ngIf="!isThread">
        <button mat-button color="primary" (click)="goToDocument()">
          <mat-icon>open_in_new</mat-icon>
          Ver
        </button>
      </div>
    </div>
    <div class="work-info" *ngIf="works.length > 0" [class.full-screen]="fullScreen() || openBudgetForm()">
      <div *ngFor="let work of works.slice(0, 7)" class="worker-card" (click)="goToWork(work)" [hidden]="work.completed_at">
        <app-chat-user [user]="work.user" matTooltip="{{ work.user?.name || 'Sin asignado'}}"></app-chat-user>
        <div class="work-name">
          {{work.work?.name}}
        </div>
        <div class="worker-details">
          <p *ngIf="work.user">{{work.user.name.split(' ')[0]}} hace {{ calculateDuration(work.started_at || work.created_at) }} en {{work.work?.name || 'otros'}}</p>
          <p *ngIf="!work.user">Sin asignado</p>
        </div>
      </div>

      <div *ngIf="works.length > 7" class="worker-card empty" (click)="goToDocument()">
        <app-chat-user text="+{{works.length - 7}}"></app-chat-user>
        <div class="work-name">
          <span>+{{works.length - 7}} más</span>
        </div>
      </div>
    </div>

    @if (budgets()) {
      @for (budget of budgets(); track budget.id) {
        <app-chat-document [document]="budget">
        </app-chat-document>
      }
    }

    <app-chat-events [events]="events" (endEvent)="endEvent($event)" [hidden]="events.length == 0"></app-chat-events>
  }
  <div class="messages-wrapper" [class.full-screen]="fullScreen() || openBudgetForm()">
    <mat-spinner *ngIf="loading()" diameter="24"></mat-spinner>
    <div class="messages-container" #messagesContainer (scroll)="onScroll($event)">
      
      <div class="message"
        *ngFor="let message of messages"
        [ngClass]="{'own-message': message.isOwn, 'system-message': message.isSystem, 'kogu-message': message.isKogu}"
        [style.z-index]="message.pictures?.length > 0 || message.upload?.length > 0 ? 10 : null"
      >
        <app-chat-user [user]="message.author" *ngIf="!message.isOwn" [isAgent]="message.isKogu"></app-chat-user>
        <app-chat-bubble [message]="message" (uploadedPhotos)="addPhotos(message, $event)" (swiperight)="replyToMessage(message)">
          <mat-menu #contextMenu="matMenu" [xPosition]="message.isOwn ? 'before' : 'after'" yPosition="below">

            @if (message.document) {
              
              <button
                  mat-menu-item
                  go-to-details
                  [element]="message.document"
                  [type]="message.document_type"
                  mode="route"
              >
                <mat-icon>visibility</mat-icon>
                <span>Ver detalles</span>
              </button>
              <button mat-menu-item (click)="downloadDocument(message)">
                <mat-icon>download</mat-icon>
                <span>Descargar {{message.document_type | human}}</span>
              </button>
            }

            <button mat-menu-item (click)="replyToMessage(message)">
              <mat-icon>reply</mat-icon>
              <span>Responder</span>
            </button>

            @if (message.calendar_event && message.isOwn) {
              <button mat-menu-item (click)="editEvent(message)">
                <mat-icon>edit</mat-icon>
                <span>Editar Evento</span>
              </button>
            }

            <button mat-menu-item (click)="copyMessage(message)">
              <mat-icon>content_copy</mat-icon>
              <span>Copiar</span>
            </button>

            @if (message.isOwn && canDelete(message)) {
              <button mat-menu-item (click)="deleteMessage(message)">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            }
          </mat-menu>
          @if(!message.deleted_at && !compactChat){
            <div [matMenuTriggerFor]="contextMenu" #menuTrigger="matMenuTrigger" (click)="menuTrigger.openMenu()" class="menu-button" [ngClass]="{'own-message': message.isOwn, 'system-message': message.isSystem, 'kogu-message': message.isKogu}">
              <mat-icon>more_vert</mat-icon>
            </div>
          }
        </app-chat-bubble>
        
      </div>

      @if(agentWorking()){
        <div class="message kogo-message">
          <app-chat-user [isAgent]="true"></app-chat-user>
          <app-chat-bubble >
            <div class="message-body">
              <p class="thinking-indicator">...</p>
            </div>
          </app-chat-bubble>
        </div>
      }
      
    </div>
    <button 
      *ngIf="readingOldMessages()"
      class="go-bottom-btn"
      (click)="scrollToBottom(false,true)">
      ⬇ Ir al final
    </button>
  </div>

  @if(!compactChat){

    <div class="current-work-container" [class.full-screen]="work" *ngIf="currentWork" >  
      <div class="current-work">
        <app-chat-user [user]="currentWork.user" [showMenu]="true"></app-chat-user>
        @if(ownWorks.length > 1){
          <div class="work-name" [matMenuTriggerFor]="worksMenu">
            <h4>{{currentWork.work?.name}}</h4>
            <i>hace {{ calculateDuration(currentWork.started_at || currentWork.created_at) }}</i>
          </div>
        }@else{
          <div class="work-name no-hover" (click)="toggleWork()">
            <h4>{{currentWork.work?.name}}</h4>
            <i>hace {{ calculateDuration(currentWork.started_at || currentWork.created_at) }}</i>
          </div>
        }
        <div class="expander" (click)="toggleWork()"></div>
        <div class="work-details" (click)="toggleWork()">
        <mat-icon>open_in_full</mat-icon>
        </div>
        <mat-menu #worksMenu="matMenu" yPosition="above" xPosition="after">
          @for(work of ownWorks; track work.id){
            <button mat-menu-item (click)="selectWork(work)">
              <mat-icon>build</mat-icon>
              <span>{{work.work?.name || 'Otros'}}</span>
            </button>
          }
        </mat-menu>
      </div>
      <div class="work-container">
        <app-work-dialog [workId]="work.id" [chatMode]="true" *ngIf="work"></app-work-dialog>
      </div>
      
    </div>

    <div class="reply-container" *ngIf="reply" [class.at-work]="ownWorks?.length > 0">
      
      <app-chat-bubble [message]="reply" [quote]="true"></app-chat-bubble>
      <button mat-icon-button (click)="cancelReply()" class="cancel-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="event-form-container" *ngIf="event" [class.at-work]="ownWorks?.length > 0">
      <form [formGroup]="eventForm" class="event-form">
        <button mat-icon-button (click)="cancelEvent()" class="cancel-button">
          <mat-icon>close</mat-icon>
        </button>
        <div class="form-row">
          <mat-form-field appearance="fill" class="no-subscript">
            <mat-label>Nombre del evento</mat-label>
            <input matInput formControlName="name" required>
          </mat-form-field>
          <app-datetime-picker
            inputAppearance="fill"
            [noSubscript]="true"
            formControlName="start_date"
            label="Fecha y hora de inicio"
          ></app-datetime-picker>
    
          <mat-form-field appearance="fill" class="no-subscript">
            <mat-label>Duración (Horas)</mat-label>
            <input matInput type="number" formControlName="duration" required min="1">
          </mat-form-field>
        </div>

      </form>
    </div>
    @if (roleService.can('create', 'budget') | async) {
      <app-budget-form
        [sourceDocument]="{
          id: chat().document_id,
          requirement_id: chat().requirement_id,
          warehouse_id: this.chat().warehouse_id,
        }"
        [sourceDocumentType]="chat().document_type"
        [formGroup]="budgetForm"
        (cancel)="closeBudgetForm()"
        [class.full-screen]="openBudgetForm()"
        [chatMode]="true"
      >
      </app-budget-form>
    }
    <div class="image-preview-container" *ngIf="imagePreviews.length > 0" [hidden]="uploadingPhotos()" [class.at-work]="ownWorks?.length > 0">
      <div *ngFor="let image of imagePreviews; let i = index" class="image-preview" [ngStyle]="{'background-image': 'url(' + image.url + ')'}">
        <button class="remove-button" (click)="removeImage(i)">X</button>
        <div class="video" *ngIf="image.file.video"><i class="fa fa-video"></i></div>
      </div>
    </div>
  }
    <div class="message-input" [class.at-work]="ownWorks?.length > 0">
      <!-- Botón para adjuntar archivos -->
      @if (isThread) {
        <button mat-icon-button [matMenuTriggerFor]="threadHistoryMenu" style="margin-right: 8px;">
          <mat-icon>history</mat-icon>
        </button>
      }
      @else {
        @if(!compactChat){
          <button mat-icon-button [matMenuTriggerFor]="attachmentMenu" style="margin-right: 8px;">
            <mat-icon>add</mat-icon>
          </button>
        }
      }

      <mat-menu #threadHistoryMenu="matMenu">
        @for(thread of threads; track thread.id){
          <button mat-menu-item (click)="selectThread(thread)">
            <mat-icon>history</mat-icon>
            <span>{{thread.first_comment?.comment || 'Ultimo Hilo'}}</span>
          </button>
        }
        <button mat-menu-item (click)="createThread()">
          <mat-icon>add</mat-icon>
          <span>Crear nuevo hilo</span>
        </button>
      </mat-menu>
    
      <mat-menu #attachmentMenu="matMenu">
        <button
          mat-menu-item
          (click)="onClickWhatsapp()"
        >
          <mat-icon svgIcon="whatsapp"></mat-icon>
          <span>Whatsapp</span>
        </button>
        @if (chat().document_type === 'Order'
              && !openBudgetForm()
              && (roleService.can('create', 'budget') | async)){
          <button
            mat-menu-item
            (click)="openBudgetForm.set(true)"
          >
            <mat-icon>attach_money</mat-icon>
            <span>{{ 'budget' | human }}</span>
          </button>
        }
        @if (!openBudgetForm()) {
          <button mat-menu-item [matMenuTriggerFor]="customWorkMenu">
            <mat-icon>build</mat-icon>
            <span>Trabajo</span>
          </button>
        }

        <button mat-menu-item (click)="addImages()">
          <mat-icon>image</mat-icon>
          <span>Imagen</span>
        </button>

        @if (!openBudgetForm()) {
          <button mat-menu-item (click)="addEvent()">
            <mat-icon>calendar_month</mat-icon>
            <span>Evento</span>
          </button>
        }
      </mat-menu>

      <mat-menu #customWorkMenu="matMenu">
        <button mat-menu-item *ngFor="let work of customWorks" (click)="addCustomWork(work)">
          <mat-icon>work</mat-icon>
          <span>{{work.name}}</span>
        </button>
      </mat-menu>
    
      <input type="file" id="chat-file" #fileChatInput multiple (change)="onFileSelected($event)" style="display:none;">
      <app-chat-input (value)="sendMessage()" [inputSignal]="inputText" [class.disabled]="agentWorking()">
      </app-chat-input>
      @if(!compactChat){
        <button mat-icon-button (click)="takePicture()" [disabled]="!inputText" *ngIf="!isThread">
          <mat-icon>camera_alt</mat-icon>
        </button>
      }
      <div class="tooltip-container">
        <button
            mat-icon-button
            (click)="sendMessage()"
            [disabled]="agentWorking() || (openBudgetForm() && (budgetForm.get('inventory_actions') | formGroup)?.controls?.length === 0)"
            class="tooltip-container"
        >
          <mat-icon>send</mat-icon>
        </button>
        @if (openBudgetForm() && (budgetForm.get('inventory_actions') | formGroup)?.controls?.length > 0) {
          <div class="tooltip-content">
            Haz clic o pulsa en enviar para crear el {{'budget' | human}}
          </div>
        }
      </div>
    </div>
  
</div>